import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import PrivacyPolicy from "../../components/PrivacyPolicy/PrivacyPolicy";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { t } from "i18next";

const PrivacyPolicyPage = () => {
  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-4"} />
      <PageTitle pageTitle={t("privacy_policy")} pagesub={"Privacy Policy"} />
      <PrivacyPolicy />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default PrivacyPolicyPage;
